import type { IMediaAboutUsResources } from "@/src/cashback/LandingPage/MediaAboutUs.Resources";

export const MediaAboutUsResourcesEn: IMediaAboutUsResources = {
    mediaArticle1: "goodie - inspirations, ocassions, shopping",
    mediaArticle2: "Digital flyers, loyalty cards, coupons and cashback in one app",
    mediaArticle3: "goodie users have saved already 12 mln zł with cashback program",
};
